import {
  PAYMENT_ALL,
  PAYMENT_GET,
  PAYMENT_DEL,
  PAYMENT_PUT,
  PAYMENT_POST,
  PAYMENT_LOADING,
  PAYMENT_ERROR,
} from '../types';

import api from '../../../utils/functions/api';

export const paymentCreate = (payload) => async (dispatch) => {
  try {
    dispatch({ type: PAYMENT_LOADING });
    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/payment_api`,
      {
        ...payload,
      },
    );
    dispatch({ type: PAYMENT_POST, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: PAYMENT_ERROR });
    throw new Error(error);
  }
};

export const paymentAll = (params = {}) => async (dispatch) => {
  try {
    dispatch({ type: PAYMENT_LOADING });
    const { name = '', size = null, page = 1, date = '', dateStart = '', dateEnd = '', status: statusFilter = '', notStatus = '' } = params;
    const q = new URLSearchParams({ name, page });
    if (size) q.set('size', size);
    if (date) q.set('date', date);
    if (dateStart) q.set('dateStart', dateStart);
    if (dateEnd) q.set('dateEnd', dateEnd);
    if (statusFilter) q.set('status', statusFilter);
    if (notStatus) q.set('notStatus', notStatus);
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/payment_api?${q.toString()}`,
    );
    if (status === 200) {
      dispatch({ type: PAYMENT_ALL, payload: data });
      return data;
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: PAYMENT_ERROR });
    throw new Error(error);
  }
};
export const paymentCreateWithExpenses = (payload) => async (dispatch) => {
  try {
    const {
      data,
      status,
    } = await api.post(
      `${process.env.REACT_APP_API_URL}/payment_api/with-expenses`,
      { ...payload },
    );
    if (status === 200) {
      dispatch({ type: PAYMENT_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: PAYMENT_ERROR });
    throw new Error(error);
  }
};

export const paymentPrepareFromIds = (payload = {}) => async (dispatch) => {
  try {
    dispatch({ type: PAYMENT_LOADING });
    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/payment_api/prepare-from-ids`,
      { ...payload },
    );
    return data;
  } catch (error) {
    console.error(error);
    dispatch({ type: PAYMENT_ERROR });
    throw error;
  }
};

export const paymentPrepareByPayee = (payload = {}) => async (dispatch) => {
  try {
    dispatch({ type: PAYMENT_LOADING });
    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/payment_api/prepare-by-payee`,
      { ...payload },
    );
    return data;
  } catch (error) {
    console.error(error);
    dispatch({ type: PAYMENT_ERROR });
    throw error;
  }
};

export const paymentComplete = (paymentId, payload = {}) => async (dispatch) => {
  try {
    dispatch({ type: PAYMENT_LOADING });
    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/payment_api/${paymentId}/complete`,
      { ...payload },
    );
    return data;
  } catch (error) {
    console.error(error);
    dispatch({ type: PAYMENT_ERROR });
    throw error;
  }
};

export const paymentGet = (id) => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/payment_api/${id}`,
    );
    if (status === 200) {
      dispatch({ type: PAYMENT_GET, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: PAYMENT_ERROR });
    throw new Error(error);
  }
};

export const paymentPut = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: PAYMENT_LOADING });
    const { data } = await api.put(
      `${process.env.REACT_APP_API_URL}/payment_api/${id}`,
      payload,
    );
    dispatch({ type: PAYMENT_PUT, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: PAYMENT_ERROR });
    throw new Error(error);
  }
};
export const paymentSplit = (id, expenses_ids) => async (dispatch) => {
  try {
    dispatch({ type: PAYMENT_LOADING });
    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/payment_api/${id}/split`,
      { expenses_ids },
    );
    dispatch({ type: PAYMENT_POST, payload: data });
    return data;
  } catch (error) {
    console.error(error);
    dispatch({ type: PAYMENT_ERROR });
    throw error;
  }
};

export const paymentUpdateSlip = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: PAYMENT_LOADING });
    const { data } = await api.patch(
      `${process.env.REACT_APP_API_URL}/payment_api/${id}/slip`,
      payload,
    );
    dispatch({ type: PAYMENT_PUT, payload: data });
    return data;
  } catch (error) {
    console.error(error);
    dispatch({ type: PAYMENT_ERROR });
    throw error;
  }
};

export const paymentDelete = (id) => async (dispatch) => {
  try {
    dispatch({ type: PAYMENT_LOADING });
    const { data } = await api.delete(
      `${process.env.REACT_APP_API_URL}/payment_api/${id}`,
    );
    dispatch({ type: PAYMENT_DEL, payload: data });
  } catch (error) {
    const { status } = error.request;
    console.error(error);

    if (status === 403) {
      const message = 'ไม่สามารถลบข้อมูลเนื่องจากยังคงมีข้อมูลอยู่ในหมวดหมู่';
      dispatch({ type: PAYMENT_ERROR, payload: { message } });
      throw new Error(message);
    } else {
      const message = 'เกิดข้อผิดพลาด';
      dispatch({ type: PAYMENT_ERROR, payload: { message } });
      throw new Error(message);
    }
  }
};
